import React from 'react';
import SquareButton from './SquareButton';

const Card = ({ children, icon, url }) => (
    <div style={styles.container} className='container'>
        <div style={styles.info}>
            {
                icon ?
                    // eslint-disable-next-line
                    <img src={icon} style={styles.icon} />
                    :
                    <></>
            }
            <div>
                {children}
            </div>
        </div>
        {
            url ?
                <SquareButton icon={'fa-solid fa-chevron-right'} onClick={() => {
                    window.open(url, '_blank');
                }} />
                :
                <></>
        }
    </div>
);

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        gap: '1.5rem'
    },
    info: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    icon: {
        width: '80px',
        height: '80px',
        borderRadius: '50%',
        marginRight: '20px'
    },
};

export default Card;